import type { CSSProperties, ReactNode } from 'react';

export interface DocCardProps {
  /** Card body content. */
  children: ReactNode;
  /** Extra utility classes appended to the card. */
  className?: string;
  /** Optional inline style, forwarded to the card element (e.g. marginTop). */
  style?: CSSProperties;
}

/**
 * Documentation card wrapper — a padded card surface.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged so
 * styling is identical. Forwards an optional `style` (the monolith's engine-doc
 * sections pass `style={{ marginTop }}`); existing style-less call-sites are
 * unaffected.
 */
export function DocCard({ children, className = '', style }: DocCardProps) {
  return (
    <div className={`card p-4 ${className}`} style={style}>
      {children}
    </div>
  );
}
